import { defineStore } from 'pinia';
export const activityStore = defineStore({
    id: 'inactivity',
    state: () => ({
        activity: false,
    }),
    actions: {
        updateActivityStore(mode: boolean) {
            this.activity = mode;
        },
        getActivityStore() {
            return this.activity;
        },
    },
});
